import { h } from 'vue';
import { ArrowUpOutlined, ArrowDownOutlined, ArrowRightOutlined } from '@ant-design/icons-vue';

export function polarisasiIcon(value) {
  const polarizationIconMap = {
    Negatif: h(ArrowDownOutlined),
    Positif: h(ArrowUpOutlined),
    Rentang: h(ArrowRightOutlined),
    'Rentang 4 Titik': h(ArrowRightOutlined),
  };

  const iconConfig = polarizationIconMap[value];
  const polarisasi = iconConfig ?? null;

  return polarisasi;
}
